/**
 * 구슬 룰렛 맵 에디터 — 데이터 모델 요약 (직접 확장할 때 여기부터 읽으면 됩니다)
 *
 * StageDef (data/maps.ts)
 *   - title: 표시 이름
 *   - goalY: 구슬 중심이 넘으면 결승으로 처리되는 월드 Y
 *   - zoomY: 카메라가 따라갈 때 참고하는 Y (lazygyu 원본과 동일)
 *   - entities?: MapEntity[] — 정적/운동학적 충돌체
 *
 * MapEntity
 *   - position: { x, y } — shape가 그려질 기준점(대부분 트랙은 0,0 + polyline 절대좌표)
 *   - type: 'static' | 'kinematic'
 *   - shape: box | circle | polyline (types/MapEntity.type.ts)
 *   - props: density, restitution, angularVelocity, (선택) life
 *
 * Box2D 생성은 Box2dPhysics.createEntities 가 담당합니다.
 */
import type { StageDef } from '../data/maps';
import type { MapEntity } from '../types/MapEntity.type';

export function cloneEntity(e: MapEntity): MapEntity {
  return JSON.parse(JSON.stringify(e)) as MapEntity;
}

export function entitySummary(e: MapEntity, index: number): string {
  const sh = e.shape;
  switch (sh.type) {
    case 'polyline':
      return `#${index} 폴리라인 (${sh.points.length}점)`;
    case 'box':
      return `#${index} 박스 (${e.position.x.toFixed(1)}, ${e.position.y.toFixed(1)})`;
    case 'circle':
      return `#${index} 원 r=${sh.radius}`;
    default:
      return `#${index}`;
  }
}

export function replaceEntityAt(
  stage: StageDef,
  index: number,
  entity: MapEntity
): StageDef {
  const entities = [...(stage.entities ?? [])];
  if (index < 0 || index >= entities.length) return stage;
  entities[index] = entity;
  return { ...stage, entities };
}

export function removeEntityAt(stage: StageDef, index: number): StageDef {
  const entities = [...(stage.entities ?? [])];
  if (index < 0 || index >= entities.length) return stage;
  entities.splice(index, 1);
  return { ...stage, entities };
}

export function insertEntity(stage: StageDef, entity: MapEntity, at?: number): StageDef {
  const entities = [...(stage.entities ?? [])];
  if (at == null || at >= entities.length) entities.push(entity);
  else entities.splice(at, 0, entity);
  return { ...stage, entities };
}
